"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateProductValue = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const create_product_value_assertion_mutation_1 = require("../create-product-value-assertion.mutation");
const useCreateProductValue = () => {
    const [createProductValueMutation] = (0, react_2.useMutation)(create_product_value_assertion_mutation_1.CREATE_PRODUCT_VALUE_ASSERTION);
    const createProductValue = (0, react_1.useCallback)((attributes, productIds, labelName) => __awaiter(void 0, void 0, void 0, function* () {
        const variableList = [];
        for (const attribute of attributes) {
            const attributeValuePairs = attribute.values.map(({ name }) => ({
                label: attribute.name,
                type: graphql_1.ProductAttributeAssertionType.Positive,
                value: name,
            }));
            for (const productId of productIds) {
                variableList.push([attributeValuePairs, productId]);
            }
        }
        const promises = variableList.map(([labels, productId]) => new Promise((resolve, reject) => {
            void createProductValueMutation({
                variables: {
                    product: {
                        id: productId,
                        clientMutationId: '',
                        labels,
                    },
                    labelName,
                },
                // Prevent Apollo from auto-merging intermediate mutation response into cache.
                // Cache is managed manually via optimistic update (Phase 1) and server data replacement (Phase 2).
                fetchPolicy: 'no-cache',
                onError: (error) => reject(new Error(error.message)),
                onCompleted: (data) => resolve(data.productAssertion),
            });
        }));
        const results = yield Promise.all(promises);
        const errors = results.filter(({ error }) => error).map(({ error }) => error);
        const errorMessage = errors.join(', ');
        if (errorMessage) {
            throw new Error(errorMessage);
        }
        return results;
    }), [createProductValueMutation]);
    return {
        createProductValue,
    };
};
exports.useCreateProductValue = useCreateProductValue;
exports.default = exports.useCreateProductValue;
